import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IIntensityTypeDropDownProps extends WithTranslation{
    handleChanges: any;
    value: string
}

const IntensityTypeDropDown =(props: IIntensityTypeDropDownProps) =>{
    const selectOptions = [
        { key: "absolute", text: props.t('intensityType.absolute'), value: "absolute" },
        { key: "strengthRelative", text: props.t('intensityType.strengthRelative'), value: "strengthRelative" },
        { key: "weightRelative", text: props.t('intensityType.weightRelative'), value: "weightRelative" }
    ];
    return(<Dropdown
        fluid
        selection
        options={selectOptions}
        onChange={props.handleChanges}
        id='intensityType'
        value = {props.value}
  />)
}

export default withTranslation('exerciseCreator') (IntensityTypeDropDown);